import React, { FC } from 'react';
import Carousel from 'react-multi-carousel';

import 'react-multi-carousel/lib/styles.css';

import {
  Item,
  Item2,
  Item3,
} from '@/components/CartPage/PaymentSuccessful/Sliders/items';

import { FormattedFinalOrder } from '@/utils/interfaces/Orders';
import {
  IPlansOffer,
  IStartSubscriptionBody,
  Product,
} from '@/utils/interfaces/Subscription';
interface Props {
  productsArray?: any[];
  plansOfferData: IPlansOffer | undefined;
  array: number;
  loadingSb: boolean;
  handleSubscribe: (data: IStartSubscriptionBody) => Promise<void>;
  formatTime: (seconds: number) => string;
  time: number;
  limitedProducts: Product[];
  remainingCount: number;
  order: FormattedFinalOrder | undefined;
}
const Sliders: FC<Props> = ({
  handleSubscribe,
  loadingSb,
  productsArray,
  array,
  plansOfferData,
  formatTime,
  limitedProducts,
  time,
  remainingCount,
  order,
}) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 641 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const items = [
    plansOfferData?.offer_available ? (
      <Item
        key='1'
        remainingCount={remainingCount}
        array={array}
        plansOfferData={plansOfferData}
        productsArray={productsArray}
        handleSubscribe={handleSubscribe}
        loadingSb={loadingSb}
        formatTime={formatTime}
        time={time}
        limitedProducts={limitedProducts}
      />
    ) : null,
    <Item2 key='2' />,
    <Item3 key='3' order={order as FormattedFinalOrder} />,
  ].filter(Boolean);
  const CustomRightArrow = ({ onClick }: { onClick?: () => void }) => {
    return (
      <button
        onClick={onClick}
        className='absolute top-0 right-0 sm:m-5 m-4 text-white sm:text-base text-sm leading-[100%] underline'
        aria-label='Next'
      >
        Skip
      </button>
    );
  };
  return (
    <div className='sm:max-w-[568px] max-w-[358px] w-full rounded-2xl overflow-hidden'>
      <Carousel
        swipeable={false}
        draggable={false}
        customLeftArrow={<></>}
        customRightArrow={<CustomRightArrow />}
        responsive={responsive}
      >
        {items}
      </Carousel>
    </div>
  );
};

export default Sliders;
